import { hasTenantCookie } from "services/tenants/tenantCookieService";
import { getObject, remove, RepositoryKey, setObject } from "utils/repository";

export interface TenantTableFilters {
    contractType: string;
    searchParameter: string;
    searchQuery: string;
}

export const DEFAULT_TENANT_TABLE_FILTERS: TenantTableFilters = {
    contractType: "all",
    searchParameter: "search",
    searchQuery: "",
};

export function saveTenantTableFilters(filters: TenantTableFilters): void {
    if (hasTenantCookie()) {
        return;
    }
    setObject(RepositoryKey.TENANT_TABLE_FILTERS, filters);
}

// Dropping tenant access reloads the page, which wipes the table's React state. The flag makes the saved filters apply
// only after that reload, so that a normal visit to the tenants view always starts unfiltered.
export function requestTenantTableFiltersRestore(): void {
    setObject(RepositoryKey.RESTORE_TENANT_TABLE_FILTERS, true);
}

// Has no side effects so that it's safe to call during rendering. Use clearTenantTableFiltersRestore to consume the
// result.
export function readTenantTableFiltersToRestore(): TenantTableFilters | undefined {
    if (getObject<boolean>(RepositoryKey.RESTORE_TENANT_TABLE_FILTERS) !== true) {
        return undefined;
    }
    return getObject<TenantTableFilters>(RepositoryKey.TENANT_TABLE_FILTERS) ?? undefined;
}

export function clearTenantTableFiltersRestore(): void {
    if (hasTenantCookie()) {
        return;
    }
    remove(RepositoryKey.RESTORE_TENANT_TABLE_FILTERS);
    remove(RepositoryKey.TENANT_TABLE_FILTERS);
}
